import React from "react";
import { Input } from "antd";

export default function InputFilter(props) {
  return (
    <Input
      style={{ width: "90%" }}
      placeholder={props.placeholder}
      onChange={(e) => props.onChange(e.target.value)}
    />
  );
}
